import { AfterViewInit, Component, ElementRef, HostBinding, OnDestroy, Renderer2 } from '@angular/core';
import { BaseContainer } from '@stylehaven/components';
import { BannerContainerComponent } from '../banner/banner-container.component';
import { MaintenanceNotificationContainerComponent } from '../maintenance-notification/maintenance-notification.component';
import { ReadExportModeNotificationContainerComponent } from '../read-export-mode-notification/read-export-mode-notification.component';

@Component({
    standalone: true,
    selector: 'med-page-header-notifications-container',
    templateUrl: './page-header-notifications-container.component.html',
    styleUrls: ['./page-header-notifications-container.component.scss'],
    imports: [
        BannerContainerComponent,
        ReadExportModeNotificationContainerComponent,
        MaintenanceNotificationContainerComponent
    ]
})
export class PageHeaderNotificationsContainerComponent extends BaseContainer implements AfterViewInit, OnDestroy {
    @HostBinding('class.has-notifications') hasNotificationsClass = false;

    private observer: MutationObserver;

    constructor(
        private readonly el: ElementRef,
        private renderer: Renderer2
    ) {
        super();
    }

    ngAfterViewInit() {
        this.updateHostClass(); // Initial check

        // Set up MutationObserver to detect changes inside the component
        this.observer = new MutationObserver(() => {
            this.updateHostClass();
        });

        this.observer.observe(this.el.nativeElement, {
            childList: true,
            subtree: true
        });
    }

    updateHostClass() {
        const targetElements: NodeList = this.el.nativeElement.querySelectorAll("[class^='sh-notification']");

        if (targetElements.length) {
            this.renderer.addClass(this.el.nativeElement, 'has-notifications');
        } else {
            this.renderer.removeClass(this.el.nativeElement, 'has-notifications');
        }
    }

    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
